/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import { Container, Box, Typography, Grid } from '@mui/material';
import cloud from './cloud.png';
import serial from './serial.png';

const LicenseRegistration = () => {
  return (
    <Container sx={{ px: 0, pb: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
        License Registration
      </Typography>
      <Box
        sx={{
          px: 3,
          py: 4,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: 1000,
          mx: 'auto',
          color: '#222',
          fontSize: '0.95rem',
          lineHeight: 1.8,
        }}
      >
        <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 3 }}>
          How to Authorize Your Plugins or Subscription
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography fontWeight="bold" sx={{ mb: 1 }}>
              Authorize with Your Serial Number
            </Typography>
            <Typography>
              1– Find your serial number on your invoice or sales confirmation
              email.
            </Typography>
            <Typography>
              2– Enter that into the dialog along with your name. Organization
              can be left blank.
            </Typography>
            <Typography>
              3– The serial number should be entered exactly as you see it, with
              the dashes.
            </Typography>
            <Typography>4– Click OK</Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography fontWeight="bold" sx={{ mb: 1 }}>
              Authorize with Your Anarchy Cloud Login
            </Typography>
            <Typography>
              1– Enter your email address into the NAME field.
            </Typography>
            <Typography>
              2– The dialog will change to show the Password field.
            </Typography>
            <Typography>3– Enter in your Password</Typography>
            <Typography>4– Click OK</Typography>
          </Grid>
        </Grid>
        {/* Image row */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 4 }}
        >
          <Grid item xs={12} sm={6} display="flex" justifyContent="center">
            <Box
              component="img"
              src={serial}
              alt="Serial Number"
              sx={{ maxWidth: '100%', height: 'auto', borderRadius: 1 }}
            />
          </Grid>
          <Grid item xs={12} sm={6} display="flex" justifyContent="center">
            <Box
              component="img"
              src={cloud}
              alt="Cloud Login"
              sx={{ maxWidth: '100%', height: 'auto', borderRadius: 1 }}
            />
          </Grid>
        </Grid>
        <Typography align="center" sx={{ my: 3 }}>
          Still have questions?{' '}
          <Box
            component="a"
            href="https://www.digitalanarchy.com/support/install.html"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#1976D2', fontWeight: 700 }}
          >
            Watch a video tutorial
          </Box>{' '}
          for detailed instructions.
        </Typography>
      </Box>
    </Container>
  );
};

export default LicenseRegistration;
